module.exports = __webpack_public_path__ + "static/media/iid.b2fc3891.svg";